// get current locale from browser if available
export const getCurrentLocale = () => {
  if (typeof window !== 'undefined') {
    const locale = window.navigator.language;
    return locale;
  } else {
    return 'en';
  }
};

const localeNumberFormatter = Intl.NumberFormat(getCurrentLocale());

export const formatLocaleNumber = (value: number): string =>
  localeNumberFormatter.format(value);
